// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';

import ProductItem from './components/ProductItem';

type Props = {
  count: number,
  price: number,
};

function DomainMiscFeesRow({ count, price }: Props) {
  const { __ } = useTranslator();
  if (count < 1) {
    return null;
  }

  return (
    <ProductItem
      label={__('Operation fees x %(count)s domain', { count })}
      detail={__(
        'Fees contains manual operations for %(count)s corporate domains',
        {
          count,
        },
      )}
      deleteDisabled
      hasTaxes
      priceBeforeTaxes={price}
    />
  );
}

export default (React.memo<Props>(
  DomainMiscFeesRow,
): React.ComponentType<Props>);
